(function () {
    'use strict';

    function configurationOptionsDataService($http) {
        var baseUrl = '[BuildifyApiHost]/api/configurationoptions';

        function loadMasterConfigurationOptions() {
            return $http.get('[BuildifyApiHost]/api/masterconfigurationoptions').then(function (response) {
                return response.data;
            });
        };

        function loadConfigurationOptions(id) {
            return $http.get(baseUrl + '/'+ id).then(function (response) {
                return response.data;
            });
        };

        function loadGeneralConfigurationOptions() {
            return $http.get(baseUrl).then(function (response) {
                return response.data;
            });
        };

        return {
            loadMasterConfigurationOptions: loadMasterConfigurationOptions,
            loadConfigurationOptions: loadConfigurationOptions,
            loadGeneralConfigurationOptions: loadGeneralConfigurationOptions
    }
    }

    configurationOptionsDataService.$inject = ['$http'];

    angular.module('ecap.common').service('configurationOptionsDataService', configurationOptionsDataService);
})();